import { withIcon } from "../Icon"

export const IconTool = withIcon(
  '<path stroke="#191A1A" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 10h3V7L6.5 3.5a6 6 0 0 1 8 8l6 6a2.121 2.121 0 1 1-3 3l-6-6a6 6 0 0 1-8-8L7 10Z"/>',
)
